// ==============================|| OVERRIDES - CARD CONTENT ||============================== //

export default function CardContent() {
  return {
    MuiCardContent: {
      variants: [
        {
          props: { variant: 'landing-card-content' },
          style: {
            backgroundColor: '#fff',
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px 16px !important',
            '&:last-child': {
              paddingBottom: '24px !important'
            }
          }
        }
      ],
      styleOverrides: {
        root: {
          padding: '24px',
          '&:last-child': {
            paddingBottom: '24px'
          }
        }
      }
    }
  };
}
